module.exports = __webpack_public_path__ + "img/gepax.072e61d5.svg";